import React, {useState} from 'react'
import {useAuth} from "../../../providers/AuthProvider";
import SupplierFormItemProvider from "../providers/SupplierFormItemProvider";
import SupplierPartnerProgramsForm from "./SupplierPartnerProgramsForm";

const levels = [
    {label: 'Entry', value: 1},
    {label: 'Mid Tier', value: 5},
    {label: 'Top Tier', value: 10}
];
const SupplierPartnerProgramsStep = ({supplierOrg, isDisabled, onEditItem, isUpdating, onChange, onSave,...props}) => {

    const {auth} = useAuth()
    const [editingIndex, setEditingIndex] = useState(false);

    const addNewArrayProp = async (propName) => {

        let models = TB.get({...supplierOrg}, propName, []);
        models.push({});

        await onChange({[propName]: models});
        return setEditingIndex(models?.length - 1)
    }

    const getModelFromProps = (partnerProgram) => {
        return {...(partnerProgram || {})}
    }

    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Partner Programs
                            </h3>
                        </div>

                        <h5 className="form-subtitle">
                            Showcase your agency's certifications and partnerships with technology providers to demonstrate expertise and credibility.
                        </h5>
                    </div>
                </div>
            </div>

            {TB.map(supplierOrg?.partnerable_programs || [], (partnerProgramItem, partnerProgramIndex) => {

                const partnerProgram = getModelFromProps(partnerProgramItem);
                return (
                    <SupplierFormItemProvider
                        key={`partnerable_programs-${partnerProgram.id}-${partnerProgramIndex}`}
                        itemIndex={partnerProgramIndex}
                        preview={<div className="px-4 flex flex-col m-0 items-start">
                            <div className="mx-10/12 mt-6 p-6 bg-gray-50 rounded-lg border-l-4 border-blue-500">
                                <div className="space-y-3">

                                    <p className="text-gray-700 text-base">
                                        {/*<i className={"mr-2 text-xl " + TB.find(partnerPlatformsIcons, ['name', partnerProgram.name])?.icon}></i>*/}
                                        <span className="font-semibold text-gray-900 text-lg">{partnerProgram.name} - </span>
                                        {partnerProgram.title && ` ${partnerProgram.title}`}
                                        {partnerProgram.level && ` (Level ${TB.find(levels,['value', parseInt(partnerProgram.level)])?.label})`}
                                        {TB.moment(partnerProgram.started_at)?.isValid() && ` since ${TB.moment(partnerProgram.started_at).format('ll')}`}
                                    </p>
                                    <div className="flex flex-wrap gap-6 text-sm text-gray-600">
                                        {partnerProgram.vertical_focus && (
                                            <span>Focus: {partnerProgram.vertical_focus}</span>
                                        )}
                                        {partnerProgram.total_certifications && (
                                            <span>Certifications: {partnerProgram.total_certifications}</span>
                                        )}
                                        {partnerProgram.marketplace_url && (
                                            <a
                                                href={partnerProgram.marketplace_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-600 hover:text-blue-800 underline"
                                            >
                                                View Marketplace Profile
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        onChange={partnerProgramProps => {
                            let changedModel = TB.cloneDeep(partnerProgram);
                            for (let [key, value] of Object.entries(partnerProgramProps)) {
                                changedModel = TB.set(changedModel, key, value);
                            }
                            return changedModel
                        }}
                        onSave={async (partnerProgramProps) => {
                            console.log('partnerProgramProps', partnerProgramProps);

                            const formatPropsForRequest = partnerProgram => {
                                let formatted = TB.pick(partnerProgram, [
                                    'id',
                                    'program_id',
                                    'category_id',
                                    'vertical_focus',
                                    'marketplace_url',
                                    'total_certifications',
                                    'level',
                                    'title',
                                    'started_at',
                                    'display_index',
                                ]);

                                return formatted
                            }
                            if (!partnerProgramProps) {
                                let partnerPrograms = TB.filter([...supplierOrg?.partnerable_programs], (partnerProgram, pPIndex) => {
                                    return partnerProgramIndex !== pPIndex;
                                });
                                if (partnerProgram?.id) {
                                    partnerPrograms = TB.map(partnerPrograms, partnerProgram => formatPropsForRequest(partnerProgram))
                                    await setEditingIndex(false);
                                    await onEditItem(false)
                                    return onSave({partnerable_programs: partnerPrograms}, true);
                                }

                                await setEditingIndex(false);
                                await onEditItem(false)
                                return onChange({partnerable_programs: partnerPrograms})
                            }else {
                                let partnerPrograms = TB.set([...supplierOrg?.partnerable_programs], partnerProgramIndex, partnerProgramProps);
                                await onChange({partnerable_programs: partnerPrograms});
                                await setEditingIndex(false);
                                await onEditItem(false)
                                partnerPrograms = TB.map(partnerPrograms, partnerProgram => formatPropsForRequest(partnerProgram))

                                return onSave({partnerable_programs: partnerPrograms}, true);
                            }
                        }}
                        model={partnerProgram}
                        isUpdating={isUpdating}
                        canEdit={editingIndex === false}
                        isEditing={editingIndex === partnerProgramIndex}
                        onEditing={async (toggle) => {
                            await onEditItem(toggle)
                            setEditingIndex(toggle ? partnerProgramIndex : false);

                        }}
                        displayName="Partner Program"
                        itemPropName="partnerable_programs">

                        <SupplierPartnerProgramsForm />

                    </SupplierFormItemProvider>
                )
            })}

            <div
                className={'white-panel talent-role-panel ' + (!!editingIndex && 'no-edit')}>
                <button
                    disabled={false}
                    className="btn btn-outline-dark" onClick={() => addNewArrayProp('partnerable_programs')}>

                    Add Partner Program #{(supplierOrg?.partnerable_programs?.length || 0) + 1} <i className="ml-1 fa fa-plus"/>
                </button>
            </div>
        </div>
    )
}
export default SupplierPartnerProgramsStep